import Plan, { PlanPair } from "../../Models/Plan"
import './YourPlan.css'

interface Props
{
	plan: Plan
}

const YourPlan = (props: Props) =>
{
	return (
		<div className="plan-container" >
			{/*<img className="plan-image" alt="" src={`../assets/${props.plan.image}.png`} />*/}
			<div className="plan-title">{props.plan.name}</div>
			{section("DETTAGLIO", props.plan.details)}
			{section("COSTI MENSILI", props.plan.periodic_costs, props.plan.total_periodic_price)}
			{section("COSTI UNA TANTUM", props.plan.una_tantum_costs, props.plan.total_una_tantum_price)}
		</div>
	)
}

const section = (title: string, entries: PlanPair[], total?: PlanPair) =>
{
	return (
		<div className="plan-section">
			<div className="plan-separator" />
			<div className="plan-subtitle">{title}</div>
			{entries.map(y =>
			{
				return (
					<div className="plan-entry" key={y.label}>
						<div className="plan-entry-label">{y.label}:</div>
						<div className="plan-entry-value">{y.value}</div>
					</div>
				)
			})}
			{total !== undefined ?
				<div className="plan-entry">
					<div>{total?.label}:</div>
					<div>{total?.value}</div>
				</div> : <div />}
		</div>
	)
}

export default YourPlan
